import { render } from "./ProfileEditPicture.vue?vue&type=template&id=59a51702"
import script from "./ProfileEditPicture.vue?vue&type=script&lang=js"
export * from "./ProfileEditPicture.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__